import { Container, Assets, TextStyle, Text, Graphics } from "pixi.js"

export async function Hud({ player }) {
  const app = window.Game.app
  const hud = new Container()

  await Assets.load("https://pixijs.com/assets/bitmap-font/desyrel.xml")

  const depth = new Text({
    style: new TextStyle({
      fontFamily: "monospace",
      fontSize: 16,
      fill: { color: "#fff" },
    }),
  })
  depth.anchor.set(1, 0)
  depth.x = window.Game.app.screen.width - 10
  depth.y = 4

  const status = new Text({
    text: "You're dead\nPress SPACE to try again",
    style: new TextStyle({
      fontFamily: "cursive",
      fontSize: 32,
      fill: { color: "#fff" },
    }),
    align: "center",
  })
  status.anchor.set(0.5, 0.5)
  status.x = app.screen.width / 2
  status.y = app.screen.height / 2 + 100

  hud.addChild(depth)
  hud.addChild(status)

  const { healthBar, tick: healthBarTick } = HealthBar({ player })
  const staminaBar = new Graphics()

  hud.addChild(healthBar)
  hud.addChild(staminaBar)

  const tick = () => {
    depth.text = `DEPTH: ${Math.round(player.y / 35)} m`

    healthBarTick()

    const staminaBarWidth =
      (player.stamina / player.maxStamina) * (player.maxStamina * 1.5)
    staminaBar.clear()
    if (player.stamina < player.maxStamina) {
      staminaBar
        .rect(
          window.Game.app.screen.width - staminaBarWidth - 10,
          64,
          staminaBarWidth,
          2,
        )
        .fill(player.expendedStamina ? "#fff3" : "#fff8")
    }

    status.visible = player.health <= 0
  }

  return { hud, tick }
}

const healthBarHeight = 18
const healthBarPadding = 3

function HealthBar({ player }) {
  const healthBarWidth = (80 * player.maxHealth) / 100

  const healthBar = new Container()
  const gfx = new Graphics()
  healthBar.addChild(gfx)

  let showNumber = false

  const text = new Text({
    style: new TextStyle({
      fontFamily: "monospace",
      fontSize: 12,
      fill: { color: "#fff" },
    }),
  })
  text.anchor.set(0.5, 0.5)
  text.x = window.Game.app.screen.width - 10 - healthBarWidth / 2
  text.y = 32 + healthBarHeight / 2

  healthBar.addChild(text)

  let lastHealth = null
  let lastShowNumber = false

  const tick = () => {
    // Don't rerender unnecessarily
    if (player.health === lastHealth && lastShowNumber === showNumber) return

    gfx.clear()

    text.visible = showNumber
    text.text = `${player.health}/${player.maxHealth}`

    gfx
      .rect(
        window.Game.app.screen.width - 10 - healthBarWidth,
        32,
        healthBarWidth,
        healthBarHeight,
      )
      .fill("#0000")
      .stroke(player.health <= 0 ? "#f00" : "#fff")

    if (!showNumber)
      gfx
        .rect(
          window.Game.app.screen.width - 10 - healthBarWidth + healthBarPadding,
          32 + healthBarPadding,
          healthBarWidth * (player.health / player.maxHealth) -
            healthBarPadding * 2,
          healthBarHeight - healthBarPadding * 2,
        )
        .fill(player.health / player.maxHealth > 0.2 ? "#fff" : "#f00")

    lastHealth = player.health
    lastShowNumber = showNumber
  }

  healthBar.eventMode = "static"
  healthBar.on("pointerenter", () => {
    showNumber = true
  })
  healthBar.on("pointerleave", () => {
    showNumber = false
  })

  return { healthBar, tick }
}
